import React, { useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, getFormValues } from 'redux-form';
import RenderSwitchComponent from './SwitchPanel';
import { BTN_FACTORY_V3_FORM } from '../../clientConstants';
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react';
import { MessageFormat } from '@paypalcorp/worldready';

const CoverFeesSwitch = ({ formValues, showBadge }) => {
  const worldReady = useContext(WorldReadyContext);

  return (
    <Field
      id="coverFeesEnabled"
      name="coverFeesEnabled"
      label="coverFeesEnabled"
      subTitle={new MessageFormat(worldReady, {
        id: 'buttonsV3.switches.coverFeesRadio.tooltip',
      }).format()}
      title={new MessageFormat(worldReady, {
        id: 'buttonsV3.switches.coverFeesRadio.label',
      }).format()}
      component={RenderSwitchComponent}
      isChecked={formValues.coverFeesEnabled === 'yes'}
      showBadge={showBadge}
    />
  );
};

const mapStateToProps = (state) => {
  const { application = {}, buttonFactoryV3 = {} } = state;

  return {
    application,
    buttonFactoryV3,
    formValues: getFormValues(BTN_FACTORY_V3_FORM)(state),
    initialValues: buttonFactoryV3.formattedButton,
  };
};

CoverFeesSwitch.propTypes = {
  formValues: PropTypes.object,
  showBadge: PropTypes.bool,
};

export default connect(mapStateToProps)(CoverFeesSwitch);
